/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AssignAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AssignAction({
  children,
  viewPath = "/DesignSystem/CheckIn/AssignConnection/Content/Content/AssignAction",
  onSubmit,
  isSubmitting
  
}) {
let selectedConnectionSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected_connection',
})
let selectedConnectionIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected_connection',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="selected_connection"
 onClick={selectedConnectionSubmitData}
 disabled={selectedConnectionIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Assign connection"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}